import React from 'react';
import { convertToLocalDate } from 'smart-react';
const isValidDate = (value) => {
  if (typeof value !== 'string') return false;

  // Strict ISO 8601 format validation (YYYY-MM-DDTHH:mm:ss.sssZ)
  const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;

  if (!isoRegex.test(value)) return false;

  const date = new Date(value);
  return !isNaN(date.getTime());
};
/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({
  editContentSlider,
  MultiViewCalenderFilterCell,
  dateRangeFilter,
  GridDateCell,
  setDateRangeFilter,
  BooleanFlagFilterCell,
  GridFlag,
}) => {
  const dataColumns = [
    {
      field: 'IntegrationSettingId',
      title: 'Setting Id',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 50,
      excludeFromFilter: true,
    },
    {
      field: 'ConnectionId',
      title: 'Connection Id',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 50,
      excludeFromFilter: true,
    },
    {
      field: 'SettingKey',
      title: 'Setting Key',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
      cell: (props) => (
        <td
          className='edit-link'
          onClick={() => {
            editContentSlider(props.dataItem);
          }}
        >
          {props.dataItem.SettingKey}
        </td>
      ),
    },
    {
      field: 'SettingValue',
      title: 'Setting Value',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
      cell: (props) => (
        <td>
          {isValidDate(props.dataItem.SettingValue)
            ? convertToLocalDate(props.dataItem.SettingValue)
            : props.dataItem.SettingValue}
        </td>
      ),
    },
    {
      field: 'IsEncrypted',
      title: 'Is Encrypted',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
      cell: GridFlag,
      filterCell: BooleanFlagFilterCell,
    },
    {
      field: 'Active',
      title: 'Active',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      cell: GridFlag,
      filterCell: BooleanFlagFilterCell,
    },
    {
      field: 'CreatedBy',
      title: 'Created By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'CreatedDate',
      title: 'Created Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'CreatedDate',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
    {
      field: 'ModifiedBy',
      title: 'Modified By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'ModifiedDate',
      title: 'Modified Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'ModifiedDate',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
  ];

  return dataColumns;
};
export default DataColumns;
